import { TCategory } from 'data/types/category';
import { getPhotoUrl } from './get-photo-url';
import { getPriceText } from './get-price-text';
import { photoUrlBase } from '../constants';

export type PreparedCategoryData = {
	id: number;
	name: string;
	description: string;
	fullCategoryUrl: string | null;
	fullPhotoUrl: string;
	priceText: string;
};

type PrepareCategoryDataFn = (data: TCategory) => PreparedCategoryData;

export const prepareCategoryData: PrepareCategoryDataFn = ({
	categoryUrl,
	categoryPhotoUrl,
	price,
	categoryId,
	categoryName,
	categoryDescription,
}) => {
	const fullCategoryUrl = categoryUrl ? `${categoryUrl}/` : null;

	const fullPhotoUrl = categoryPhotoUrl ? getPhotoUrl(categoryPhotoUrl) : photoUrlBase;

	const priceText = price ? getPriceText(price) : '';

	return {
		id: categoryId,
		name: categoryName,
		description: categoryDescription,
		fullCategoryUrl,
		fullPhotoUrl,
		priceText,
	};
};
